export default "__VITE_ASSET__CrXERxAa__"